import Storage from 'storage';
import Service from './Service';

class AccountService extends Service {
  access() {
    const self = this;
    const promise = new Promise(async (resolve, reject) => {
      try {
        const response = await self.fetchApi().get('account/access');
        const { data } = response;
        Storage.saveModulesAccess(data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });

    return promise;
  }

  me() {
    const self = this;
    const promise = new Promise(async (resolve, reject) => {
      try {
        const response = await self.fetchApi().get('account/me');
        const { data } = response;
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });

    return promise;
  }

  isAuthotized(url) {
    let urlProtected = url;

    const accesses = Storage.getModulesAccess();

    if (urlProtected.includes('admin')) {
      const modulesAvaliable = accesses.filter(a => a.accesible);

      const modulo = modulesAvaliable.find(a => {
        if (urlProtected.includes('/admin/quiz')) {
          urlProtected = '/admin/quiz';
        }
        const subModulo = a.subModulos.find(b => b.url.includes(urlProtected));

        if (subModulo) {
          return subModulo;
        }

        return false;
      });

      if (!modulo) {
        return false;
      }
      return modulo.accesible;
    }
    const module = accesses.find(a => a.nombre === 'Interface');

    if (!module) return false;
    return module.accesible;
  }

  hasAdmin() {
    const accesses = Storage.getModulesAccess();

    let hasAccess = false;

    accesses.forEach(a => {
      if (a.nombre !== 'Interface') {
        if (a.accesible && !hasAccess) {
          hasAccess = true;
        }
      }
    });

    return hasAccess;
  }

  hasModule(moduleName) {
    const accesses = Storage.getModulesAccess();

    const access = accesses.find(a => a.nombre === moduleName);

    return access.accesible;
  }

  allowedModules() {
    const accesses = Storage.getModulesAccess();

    const access = accesses.filter(
      a => a.accesible && a.nombre !== 'Interface',
    );

    return access;
  }

  allowInterfaceView() {
    const accesses = Storage.getModulesAccess();

    const access = accesses.filter(
      a => a.accesible && a.nombre === 'Interface',
    );

    if (access.length === 0) {
      return false;
    }

    return access[0].accesible;
  }

  firstAdminRoute() {
    const modules = this.allowedModules();
    if (!modules) {
      return '/';
    }

    if (!modules[0].subModulos.length) {
      return '/';
    }

    return modules[0].subModulos[0].url;
  }
}

export default AccountService;
